import { Anchor, Container, Text, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { HOME_PATH } from "../../auth/redirectTarget";

/** Раздел, модуля которого нет в составе сервера (ADR-0083, п. 4 и 6). */
export function SectionUnavailable(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Title order={2}>{t("modules.unavailableTitle")}</Title>
      <Text mt="sm">{t("modules.unavailableText")}</Text>
      <Anchor component={Link} to={HOME_PATH} mt="md" display="block">
        {t("modules.goHome")}
      </Anchor>
    </Container>
  );
}
